function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var _excluded = ["children", "className", "disabled", "onClick", "as", "selected"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
import { bool, elementType, func, node, string } from "prop-types";
import classNamesMaker from "classnames";
import { useDropdown } from "#library/components/Dropdown/components/Provider";
import { hideDropdownMenu } from "#library/components/Dropdown/Dropdown.actions";
import styles from "#library/components/Dropdown/styles/dropdown.module.css";
export var defaultProps = {
  className: null,
  disabled: false,
  onClick: function onClick() {},
  as: "button",
  selected: false
};
export var Item = function Item(props) {
  var children = props.children,
    className = props.className,
    _props$disabled = props.disabled,
    disabled = _props$disabled === void 0 ? false : _props$disabled,
    onClick = props.onClick,
    _props$as = props.as,
    as = _props$as === void 0 ? "button" : _props$as,
    _props$selected = props.selected,
    selected = _props$selected === void 0 ? false : _props$selected,
    restProps = _objectWithoutProperties(props, _excluded);
  var _useDropdown = useDropdown(),
    state = _useDropdown.state,
    dispatch = _useDropdown.dispatch;
  var Component = as;
  var itemClassNames = classNamesMaker(styles["jds-Dropdown__item"], _defineProperty({}, styles["jds-Dropdown__item--selected"], selected), className);
  var handleClick = function handleClick(event) {
    event.currentTarget.blur();
    dispatch(hideDropdownMenu());
    if (onClick) {
      onClick(event, state);
    }
  };
  var itemProps = _objectSpread(_objectSpread({}, restProps), {}, {
    className: itemClassNames,
    disabled: disabled,
    onClick: handleClick,
    tabIndex: disabled ? "-1" : null
  });

  // In case of disable, simply add a div
  if (disabled) {
    Component = "div";
  }
  return /*#__PURE__*/React.createElement("li", {
    className: styles["jds-Dropdown__itemWrapper"]
  }, /*#__PURE__*/React.createElement(Component, _extends({
    className: styles["jds-Dropdown__item"]
  }, itemProps), children));
};
Item.propTypes = {
  children: node.isRequired,
  className: string,
  disabled: bool,
  onClick: func,
  as: elementType,
  selected: bool
};